/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * This widget allows to create a foldable widget over the map.
 *
 * @class Foldable
 * @namespace L
 * @extends L.Control
 * @module Widgets
 * @constructor
 * @method foldable
 * @param {Object} [options] Options to be passed to the foldable control
 * @param {String} [options.className=""] Class prefix that will be added to container
 * @param {String} [options.title=""] Title of the container. If it's null the title will be hidden.
 * @param {Object} [options.close=null] If is an object the Close button will be appear
 * @param {String} [options.close.text] Text displayed in the Close button
 * @param {String} [options.close.image] Image of the Close button
 * @param {Object} [options.show=null] If is an object the Show button will be appear
 * @param {String} [options.show.text] Text displayed in the Show button
 * @param {String} [options.show.image] Image of the Show button
 * @param {Boolean} [options.closeOnClick=false] Should component collapse when clicked
 * @param {Boolean} [options.closeOnMapClick=true] Should component collapse when map is clicked
 * @param {"topright"|"topleft"|"bottomright"|"bottomleft"} [options.position="topright"] Position on a map
 * @param {String} [options.content=null] Initial content of the widget. Should be a string with valid HTML syntax.
 * @param {Boolean} [options.collapsed=false] Initial state of the foldable widget
 * @param {Boolean} [options.responsive=false] Listens to window resize events and adjusts the content height to 
 * fit the map, when the map size changes.
 *
 * @example
 * ```javascript
 * var widget = new L.Foldable({
 *   title: 'Foldable widget',
 *   closeOnClick: true,
 *   show: {
 *     text: 'show'
 *   }
 * });
 * widget.addTo(map);
 * ```
 */
/* jshint nomen:false */
define(['display/map', 'services/utils'],
    function(L, Utils) {
        'use strict';

        var zIndex = 1001;

        var classes = {
            contentContainer: 'tomtom-foldable__content',
            contentHeader: 'tomtom-foldable__content-header',
            contentBody: 'tomtom-foldable__content-body',
            collapsed: 'tomtom-foldable--collapsed',
            footerContainer: 'tomtom-foldable__footer',
            footerBody: 'tomtom-foldable__footer-body'
        };

        function createContainer(options) {
            var prefix = Utils.isString(options.className) ? options.className : '';
            var className = (prefix + ' tomtom-foldable leaflet-popup-content-wrapper').trim();
            return L.DomUtil.create('div', className);
        }

        function createCloseButton(container, options) {
            var button;
            if (!options.close) {
                return null;
            }
            button = L.DomUtil.create(
                'button',
                'tomtom-foldable__close tomtom-foldable--clickable',
                container
            );
            if (options.close.text) {
                button.innerHTML = options.close.text;
            } else if (options.close.image) {
                button.style.cssText = 'background-image: url(' + options.close.image + '); ';
            }
            return button;
        }

        function createShowButton(container, options) {
            var button;
            if (!options.show) {
                return null;
            }
            button = L.DomUtil.create(
                'button',
                'tomtom-foldable__show tomtom-foldable--clickable',
                container
            );
            if (options.show.text) {
                button.innerHTML = options.show.text;
            } else if (options.show.image) {
                button.style.cssText = 'background-image: url(' + options.show.image + '); ';
            }
            return button;
        }

        function createTitle(container, options) {
            var title = null;
            title = L.DomUtil.create('h4', 'tomtom-foldable__title', container);
            if (Utils.isString(options.title)) {
                title.innerHTML = options.title;
            }
            return title;
        }

        function createFooter(container, options) {
            var footer = L.DomUtil.create('div', classes.footerBody, container);
            if (options.footer instanceof HTMLElement) {
                footer.appendChild(options.footer);
            }
            return footer;
        }

        function createContentContainer(container, options) {
            var content = L.DomUtil.create('div', classes.contentBody, container);
            if (options.content) {
                content.innerHTML = options.content;
            }
            return content;
        }

        function createDomElements() {
            this.container = createContainer(this.options);

            this._header = L.DomUtil.create('div', 'tomtom-foldable__header', this.container);
            createTitle(this._header, this.options);
            this._close = createCloseButton(this._header, this.options);
            this._show = createShowButton(this._header, this.options);
            this._content = L.DomUtil.create('div', classes.contentContainer, this.container);
            this._contentHeader = L.DomUtil.create('div', classes.contentHeader, this._content);
            this._contentBody = createContentContainer(this._content, this.options);
            if (this.options.footer) {
                this._footer = L.DomUtil.create('div', classes.footerContainer, this.container);
                createFooter(this._footer, this.options);
            }
            return this.container;
        }

        function clearElementContent(element) {
            while (element.firstChild) {
                element.removeChild(element.firstChild);
            }
        }

        function addContent(content, parent) {
            var element;

            if (typeof content === 'undefined') {
                return;
            }

            if (content instanceof HTMLElement) {
                element = content;
            } else {
                element = document.createTextNode(content);
            }

            parent.appendChild(element);
        }

        L.Foldable = L.Control.extend({

            options: {
                title: '',
                close: null,
                closeOnClick: false,
                closeOnMapClick: true,
                show: null,
                position: 'topright',
                collapsed: false,
                content: null,
                responsive: false
            },

            initialize: function(options) {
                L.setOptions(this, options);
            },

            /**
             * Binds handlers to events and creates HTML elements used by the
             * component. Called when added control to a map.
             *
             * @ignore
             * @method onAdd
             * @param {Object} map Leaflet map to add control to.
             * @example
             * ```javascript
             * var widget = new L.Foldable();
             * widget.addTo(map);
             * ```
             * @return {HTMLElement}
             */
            onAdd: function(map) {
                this._map = map;

                if (this.options.closeOnMapClick) {
                    this._map.on('preclick', this.fold, this);
                }

                createDomElements.call(this);

                L.DomEvent.disableScrollPropagation(this.container);
                L.DomEvent.disableClickPropagation(this.container);

                L.DomEvent.on(this.container, 'click', this._bringToFront, this);

                if (this.options.closeOnClick) {
                    L.DomEvent.on(this._content, 'click', this.fold, this);
                }

                if (this._close) {
                    L.DomEvent.on(this._close, 'click', this.fold, this);
                }

                if (this._show) {
                    L.DomEvent.on(this._show, 'click', this.unfold, this);
                }

                if (this.options.collapsed) {
                    this.fold();
                } else {
                    this.unfold();
                }

                if (this.options.responsive) {
                    this._setContentBodyMaxHeightRef = Utils.debounce(this, this._setContentBodyMaxHeight, 250);
                    window.addEventListener('resize', this._setContentBodyMaxHeightRef);
                }

                return this.container;
            },

            /**
             * Removes event listeners added by onAdd method.
             * Called on foldable.remove()
             *
             * @ignore
             * @method onRemove
             * @param {Object} map Leaflet map to remove control from.
             * @example
             * ```javascript
             * var widget = new L.Foldable();
             * widget.addTo(map);
             * // some code here...
             * widget.remove();
             * ```
             */
            onRemove: function(map) {
                map.off('preclick', this.fold, this);
                if (this.options.closeOnClick) {
                    L.DomEvent.off(this._content, 'click', this.fold, this);
                }
                if (this._close) {
                    L.DomEvent.off(this._close, 'click', this.fold, this);
                }
                if (this._show) {
                    L.DomEvent.off(this._show, 'click', this.unfold, this);
                }
                L.DomEvent.off(this.container, 'click', this._bringToFront, this);
                if (this._timeout) {
                    clearTimeout(this._timeout);
                }
                if (this.options.responsive) {
                    window.removeEventListener('resize', this._setContentBodyMaxHeightRef);
                }
            },

            /**
             * Folds the content and shows the <b>show</b> button (to unfold it again later).
             *
             * This method is executed automatically when the widget loose focus (e.g. the user starts interacting
             * with another widget or the map).
             *
             * @method fold
             * @chainable
             * @example
             * ```javascript
             * var widget = new L.Foldable({collapsed: false});
             * widget.addTo(map);
             * widget.setContent('No data');
             * widget.fold();
             * ```
             * @return {L.Foldable}
             */
            fold: function() {
                this.container.classList.add(classes.collapsed);
                this._content.style.maxHeight = 0;
                return this;
            },

            _isCollapsed: function() {
                return this.container.classList.contains(classes.collapsed);
            },

            _setContentBodyMaxHeight: function() {
                //This hardcoded offset is used to not cover copyrights
                var additionalOffset = 60;
                var mapRect = this._map.getContainer().getBoundingClientRect();
                var mapHeight = mapRect.height;
                var offset = this.container.offsetTop;

                if (this._footer) {
                    offset = Math.abs(offset + this._footer.getBoundingClientRect().height);
                }
                if (this._header) {
                    offset = Math.abs(offset + this._header.getBoundingClientRect().height);
                }

                this._content.style.maxHeight = Math.floor(mapHeight - offset - additionalOffset) + 'px';
            },

            /**
             * Unfolds component's content.
             *
             * This method is executed when the user presses the <b>show</b> button.
             *
             * @method unfold
             * @chainable
             * @example
             * ```javascript
             * var widget = new L.Foldable();
             * widget.addTo(map);
             * widget.unfold();
             * ```
             * @return {L.Foldable}
             */
            unfold: function() {
                this.container.classList.remove(classes.collapsed);
                this._setContentBodyMaxHeight();
                return this;
            },

            /**
             * Clears all the widget's content.
             *
             * @method clear
             * @chainable
             * @example
             * ```javascript
             * var widget = new L.Foldable();
             * widget.addTo(map);
             * // some time later
             * widget.clear();
             * ```
             * @return {L.Foldable}
             */
            clear: function() {
                clearElementContent(this._contentBody);
                clearElementContent(this._contentHeader);
                return this;
            },

            /**
             * It appends content into the results list.
             *
             * @method addContent
             * @chainable
             * @param {String|HTMLElement} content content to append
             * @example
             * ```javascript
             * var results = [1, 2, 3];
             * var widget = new L.Foldable();
             * widget.addTo(map);
             * widget.setContent('Length: ');
             * widget.addContent(results.length);
             * ```
             * @return {L.Foldable}
             */
            addContent: function(content) {
                addContent(content, this._contentBody);
                if (!this._isCollapsed()) {
                    this._setContentBodyMaxHeight();
                }

                return this;
            },

            /**
             * It appends content into the results list header.
             *
             * @method addContentHeader
             * @chainable
             * @param {String|HTMLElement} content content to append
             * @example
             * ```javascript
             * var widget = new L.Foldable();
             * widget.addTo(map);
             * widget.addContentHeader('This is a header');
             * ```
             * @return {L.Foldable}
             */
            addContentHeader: function(content) {
                addContent(content, this._contentHeader);
                if (!this._isCollapsed()) {
                    this._setContentBodyMaxHeight();
                }

                return this;
            },

            /**
             * Sets (and replaces) all the content of the results list.
             *
             * @method setContent
             * @param {String|HTMLElement} content new content
             * @chainable
             * @example
             * ```javascript
             * var widget = new L.Foldable();
             * widget.addTo(map);
             * widget.setContent('Initial content');
             * widget.setContent('New content');
             * ```
             * @return {L.Foldable}
             */
            setContent: function(content) {
                return this.clear().addContent(content);
            },

            _bringToFront: function() {
                zIndex += 1;
                this.container.parentElement.style.zIndex = zIndex;
            }

        });

        return function(options) {
            return new L.Foldable(options);
        };
    }
);



// WEBPACK FOOTER //
// ./widgets/controls/foldable.js